"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupTagManagementSystems = setupTagManagementSystems;
var _logger = require("../logger");
var _gtm = require("./gtm");
const logger = _logger.mainLogger.createChild('tag-management-setup');
function setupTagManagementSystems({
  gtm
}) {
  // So far, only GTM is used. Later on, we might add Baidu analytics for China, App Insights, etc.
  // This should be rather dynamic, based on configuration data.
  const gtmHandler = (0, _gtm.gtmInit)(gtm);
  const tagManagementHandlers = [gtmHandler];
  const tagManagementHandler = (event, message) => tagManagementHandlers.forEach(handler => handler(event, message));
  logger.info('Tag management systems initialized. GTM is the only active system.');
  return tagManagementHandler;
}